export const getBorderErrorOrWarningClassFromMessage = (messageArr) => {
    if (!messageArr) return ""
    if (messageArr.some(m => m.type === "error")) return "border-color-danger"
    if (messageArr.some(m => m.type === "warning")) return "border-color-warning"
    return ""
}
